
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welcome/register",
      function () {
        return require("private-next-pages/welcome/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/welcome/register"])
      });
    }
  